import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CORE_CONFIGURATION } from '../../core/configuration';
import { ApiModule } from './api.module';
import { BaseApiService } from './base-api.service';
import { SessionState, SessionStateModel } from '../session';
import { Store } from '@ngxs/store';
import { buildAwsApi } from '../util.class';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

export interface Notifications {
    billingObject: string,
    toggleEnabled: boolean,
    status: any

}

@Injectable({
  providedIn: ApiModule,
  deps: [BaseApiService],
})

export class NewsNotificationsApiService {
  keyMapAWS: any;
  private aemPath: string = '/content/myvf-business/configurations/push-notification.contents.json';

  constructor(private http: BaseApiService, @Inject(CORE_CONFIGURATION) private config, private _store: Store, private baseHttp:HttpClient) {
    const { keyMapAWS }: SessionStateModel = this._store.selectSnapshot(SessionState);
    this.keyMapAWS = keyMapAWS;
  }


  getNotifications(billingObject): Observable<Notifications> {
    const apiAWS = buildAwsApi(this.keyMapAWS, 'retrieve_push_notification_preference', {billingObject:billingObject});

    return this.http.get({
      apiBasePath: this.config.apiBasePath,
      path: apiAWS,
      awsApi: apiAWS !== null
    });
  }

  setNotifications(body:any): Observable<any> {
    const apiAWS = buildAwsApi(this.keyMapAWS,'update_push_notification_preference' , {});
    return this.http.post({
      apiBasePath: this.config.apiBasePath,
      path: apiAWS,
      awsApi: apiAWS !== null,
      body:body
    });
  }

  getAemConfig() {
    return this.baseHttp.get(this.config.aemBasePath+this.aemPath);
  }

}
